<template>
    <c-dialog ref="dialog" mode="slide" width="75vw" enable-flex mask-close :button="false">
        <c-table ref="productList">
            <c-table-column
                    label="提现申请单"
                    name="apply_no"
                    width="120"
            >
            </c-table-column>

            <c-table-column
                    label="支付渠道"
                    name="apply_no"
                    width="90"
                    v-if="withdraw_account_type == 2"
            >
                <template #default="{data}">
                    <c-state async tag dict="CHECK_PAYMENT_CHANNEL" :value="data.check_payment_channel"></c-state>
                </template>
            </c-table-column>

            <c-table-column
                    label="提现申状态"
                    name="apply_no"
                    width="90"
            >
                <template #default="{data}">
                    <c-state tag async dict="WITHDRAW_STATUS" :value="data.withdraw_status"></c-state>
                </template>
            </c-table-column>

            <c-table-column
                    name="withdraw_amount"
                    label="提现金额"
                    width="80"
            >
                <template #default="{data}">
                    <span style="color: black">￥{{data.withdraw_amount||0}}</span>
                </template>
            </c-table-column>

            <c-table-column
                    name="withdraw_fee"
                    label="手续费"
                    width="80"
                    v-if="withdraw_account_type == 1"
            >
                <template #default="{data}">
                    <span style="color: red">￥{{data.withdraw_fee||0}}</span>
                </template>
            </c-table-column>

            <c-table-column
                    name="arrival_amount"
                    label="预计到账金额"
                    width="80"
                    v-if="withdraw_account_type == 1"
            >
                <template #default="{data}">
                    <span style="color: green">￥{{data.arrival_amount||0}}</span>
                </template>
            </c-table-column>

            <c-table-column
                    label="提现打款银行卡"
                    width="200"
            >
                <template #default="{data}">
                    <span>【{{data.bank_name}}】{{data.bank_card_no}}</span>
                </template>
            </c-table-column>

            <c-table-column
                    name="create_user_realname"
                    label="申请人"
                    width="130"
            >
            </c-table-column>

            <c-table-column
                    name="create_date"
                    label="申请时间"
                    width="130"
            >
            </c-table-column>

            <c-table-column
                    type="button"
                    label="操作"
                    width="80"
                    button-limit="6"
                    v-if="withdraw_account_type == 2"
            >
                <template #default="{data}">
                    <c-table-button icon="tf-detail" @click="globalDialog('saasWithdrawApplyDetail', {props: {id: data.id}})">查看</c-table-button>
                </template>
            </c-table-column>
        </c-table>
    </c-dialog>
</template>

<script>

export default {
    name: 'withdrawApplyList',

    components: {
    },

    props: {
        withdraw_account_type: [String, Number],//提现账户类型：1=通联余额账户；2=三方余额
        withdraw_user_type: [String, Number]// 提现申请人类型：1=商家主账号 2=商家子账号 3=平台会员
    },

    data() {
        return {
            detailData: {},
            check_order_id:0,                  //核销单ID
            check_confirm_id:0,               //核销确认单ID
        }
    },

    computed: {
    },

    methods: {
        /********搜索************/
        searchHandle(data){
            if (!data){
                data = {};
            }
            data.withdraw_account_type = this.withdraw_account_type;
            data.withdraw_user_type = this.withdraw_user_type;
            this.$refs.productList.load({
                url: '/withdraw/list',
                data
            });
        },
        open() {
            this.searchHandle();
            this.$refs.dialog.open({
                title: (this.withdraw_account_type==1?'【通联账户】':'【三方同售账户】')+'提现记录'
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
    .logs-list {
        padding: 10px 10px;

        li {
            padding: 4px 0;
            line-height: 16px;
            font-size: 13px;
            color: #666;
        }
    }
</style>